 import wixLocation from 'wix-location';
 import { biLoggerFactory } from 'wix-private';

 const biLogger = biLoggerFactory('lp', 19, { msid: 'aaffc05f-e278-4f75-b765-8c72c05765fb' });
 const buttons = {
     startNow: "start now",
     startCreating: "start creating",
     onlineStore: "online store",
     JPPBigCTA: "join partner program big cta",
     JPPSmallCTA: "join partner program small cta",
     letsTalk: "Let’s Talk"
 }
 const topic = "wix partners site";

 $w.onReady(function () {
     pageEvents();

     changeBagColor()
     // setVideosThumbnails()
     vidHover()
     // intervalSlideshow()
     setHoverInterval()
     setHoverBlog()
 });

 let checkIfIntervalOn = true

 export function setHoverInterval() {

     let myInterval = setInterval(intervalSlideshow, 4000);

     $w("#boxBagsColors").onMouseIn((event) => {
         clearInterval(myInterval);
         checkIfIntervalOn = false

     });

     $w("#boxBagsColors").onMouseOut((event) => {
         checkIfIntervalOn = true
         myInterval = setInterval(intervalSlideshow, 4000);

     });
 }

 export function setHoverBlog() {

     console.log("setHoverBlog")

     console.log($w("#textThumb1").html)
     console.log($w("#textThumb2").html)
     console.log($w("#textThumb3").html)

     $w("#buttonVid1").onMouseIn((event) => {
         $w("#textThumb1").html = `<p class="font_3" style="color: #166DFF">Red Collar&rsquo;s humanistic approach to award-winning web design</p>`

     });

     $w("#buttonVid1").onMouseOut((event) => {
         $w("#textThumb1").html = `<p class="font_3" style="color: #000">Red Collar&rsquo;s humanistic approach to award-winning web design</p>`

     });

     //

     $w("#buttonVid2").onMouseIn((event) => {
         $w("#textThumb2").html = `<p class="font_3" style="color: #166DFF">How eCommerce brands can prepare for a holiday season like no other</p>`

     });

     $w("#buttonVid2").onMouseOut((event) => {
         $w("#textThumb2").html = `<p class="font_3" style="color: #000">How eCommerce brands can prepare for a holiday season like no other</p>`

     });

     //

     $w("#buttonVid3").onMouseIn((event) => {
         $w("#textThumb3").html = `<p class="font_3" style="color: #166DFF">3 agencies recommend small changes that make a big impact</p>`

     });

     $w("#buttonVid3").onMouseOut((event) => {
         $w("#textThumb3").html = `<p class="font_3" style="color: #000">3 agencies recommend small changes that make a big impact</p>`

     });
 }

 //

 export function intervalSlideshow() {

     if (checkIfIntervalOn) {
         setTimeout(function () {
             hideAllImages()
             $w("#imageBagColor1").show()

         }, 1000);
     }

     if (checkIfIntervalOn) {
         setTimeout(function () {
             hideAllImages()
             $w("#imageBagColor2").show()

         }, 2000);
     }

     if (checkIfIntervalOn) {
         setTimeout(function () {
             hideAllImages()
             $w("#imageBagColor3").show()

         }, 3000);
     }

     if (checkIfIntervalOn) {

         setTimeout(function () {
             hideAllImages()
             $w("#imageBagColor4").show()

         }, 4000);

     }

     function hideAllImages() {
         $w("#imageBagColor1").hide()
         $w("#imageBagColor2").hide()
         $w("#imageBagColor3").hide()
         $w("#imageBagColor4").hide()
     }

 }

 export function setVideosThumbnails() {

     $w("#videoPlayer1").onEnded((event) => {
         showAllThumbnails()

     });

     $w("#videoPlayer2").onEnded((event) => {
         showAllThumbnails()

     });

     $w("#videoPlayer3").onEnded((event) => {
         showAllThumbnails()

     });

     $w("#buttonVid1").onClick((event) => {
         showAllThumbnails()
         pauseAllVideos()

         $w("#boxThumbnail1").hide()
         $w("#videoPlayer1").play()

     });
     $w("#buttonVid2").onClick((event) => {
         showAllThumbnails()
         pauseAllVideos()

         $w("#boxThumbnail2").hide()
         $w("#videoPlayer2").play()

     });

     $w("#buttonVid3").onClick((event) => {
         showAllThumbnails()
         pauseAllVideos()

         $w("#boxThumbnail3").hide()
         $w("#videoPlayer3").play()

     });

     function pauseAllVideos() {
         $w("#videoPlayer1").pause()
         $w("#videoPlayer2").pause()
         $w("#videoPlayer3").pause()

     }

     function showAllThumbnails() {
         $w("#boxThumbnail1").show()
         $w("#boxThumbnail2").show()
         $w("#boxThumbnail3").show()

     }
 }

 export function changeBagColor() {

     $w("#buttonBagColor1").onMouseIn((event) => {
         hideAllImages()
         $w("#imageBagColor1").show()

     });

     $w("#buttonBagColor2").onMouseIn((event) => {
         hideAllImages()
         $w("#imageBagColor2").show()

     });

     $w("#buttonBagColor3").onMouseIn((event) => {
         hideAllImages()
         $w("#imageBagColor3").show()

     });

     $w("#buttonBagColor4").onMouseIn((event) => {
         hideAllImages()
         $w("#imageBagColor4").show()

     });

     function hideAllImages() {
         $w("#imageBagColor1").hide()
         $w("#imageBagColor2").hide()
         $w("#imageBagColor3").hide()
         $w("#imageBagColor4").hide()
     }
 }

 export function vidHover() {

     $w("#boxThumbnail1").onMouseIn((event) => {
         hideAllImages()
         $w("#boxHoverVid1").show()

     });

     $w("#boxThumbnail2").onMouseIn((event) => {
         hideAllImages()
         $w("#boxHoverVid2").show()

     });

     $w("#boxThumbnail3").onMouseIn((event) => {
         hideAllImages()
         $w("#boxHoverVid3").show()

     });

     //

     $w("#boxThumbnail1").onMouseOut((event) => {
         hideAllImages()

     });

     $w("#boxThumbnail2").onMouseOut((event) => {
         hideAllImages()

     });

     $w("#boxThumbnail3").onMouseOut((event) => {
         hideAllImages()

     });

     function hideAllImages() {
         $w("#boxHoverVid1").hide()
         $w("#boxHoverVid2").hide()
         $w("#boxHoverVid3").hide()
     }
 }

 function pageEvents() {
     $w("#startNowHeader").onClick(() => {
         fireEvent(buttons.startCreating)
     })
     $w("#startCreatingNow").onClick(() => {
         fireEvent(buttons.startCreating);
     })
     $w("#box146").onClick(() => {
         fireEvent(buttons.startCreating);
     })
     $w("#box165").onClick(() => {
         fireEvent(buttons.startCreating);
     })
     $w("#startCreatingThree").onClick(() => {
         fireEvent(buttons.startCreating);
     })
     $w("#boxOnlineStore").onClick(() => {
         fireEvent(buttons.onlineStore);
     })
     $w("#box179").onClick(() => {
         fireEvent(buttons.JPPSmallCTA);
     })
     $w("#joinPartner").onClick(() => {
         fireLetsTalkEvent(buttons.letsTalk);
     })
 }

 async function fireEvent(button) {
     try {
         const biEventObject = {
             evid: 703,
             button_name: button,
             is_valid: true,
             topic: topic,
             url: wixLocation.url
         };
         await biLogger.log(biEventObject);
     } catch (error) {
         console.log(error, "sth went wrong")
     }
 }

 async function fireLetsTalkEvent(button) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: button,
            is_valid: true,
            topic: "partners site",
            url: wixLocation.url,
            Additional_info: "eComme bottom fold"
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}